import * as moment from "moment";

export class PTDateTimeHelper
{
    public static getDateWithoutTimezoneInfo(date: string) {
        return date? new Date(moment(date).utc().format("DD MMM YYYY HH:mm")): null;
    }
    
    public static convertToUtc(date: string | Date, time: string | Date, portOffset: string = null): string {
        if (date) {
            const offset = portOffset? portOffset: "+00:00";
            time = moment(time).toDate()
            date = moment(date).toDate();
            date.setHours(time.getHours(), time.getMinutes())
            date = moment(date).utc().utcOffset(offset, true).toDate();
            const year = date.getFullYear().toString();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            const hour = date.getHours().toString().padStart(2, "0");
            const minute = date.getMinutes().toString().padStart(2, "0");
            //2022-09-16T13:00:00.000Z
            return `${year}-${month}-${day}T${hour}:${minute}:00.000Z`;
        }
        return null;
    }
}